import type { FacetChangeOrigin } from "./models/facets.model";

export class GetFacets {
  static readonly type = '[Facets] - Get Facets';
}

export class SetFacet {
  static readonly type = '[Facets] - Set Facet';
  constructor(public id: string, public origin: FacetChangeOrigin) {}
}

export class ResetStore {
  static readonly type = '[Facets] - Reset Store';
}

export class ApplyFacets {
  static readonly type = '[Facets] - Apply Facets';
}

export class ResetFacets {
  static readonly type = '[Facets] - Reset facets';
}